type InputBaseProps = {
  label: string;
  required: boolean;
  icon?: React.ReactNode | null;
  helperText?: string;
  children: React.ReactNode;
  error?: string | null;
}

const InputBase = ({ label, required, icon = null, helperText = '', children, error = '' }: InputBaseProps) => {
  return (
    <div>
      <label htmlFor={label} className="flex items-center text-sm font-medium text-gray-700 mb-2">
        {icon}
        {label}
        {required && <span className="ml-1 text-red-500">*</span>}
      </label>
      {children}
      {helperText && (
        <p className="mt-1 text-xs text-gray-500">{helperText}</p>
      )}
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default InputBase;